import React, { useState } from 'react';
import { number, func, object, array } from 'prop-types';
import Button from 'react-bootstrap/Button';
import { IoMdCloseCircle } from 'react-icons/io';

import WalletPaymentMethodIcon from './WalletPaymentMethodIcon';
import getSymbolFromCurrency from 'currency-symbol-map';
import DeletePaymentMethodModalConfirmation from './DeletePaymentMethodModalConfirmation';
import WalletPaymentMethodAddressModal from './WalletPaymentMethodAddressModal';

function WalletPaymentMethod({ paymentMethod, userId, fetchPaymentMethods, countries }) {
    const { id, brand, expMonth, expYear, last4, name, billingAddress, isAbtraGiftCard, abtraGiftCardCredit, abtraGiftCardCurrency } = paymentMethod;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showAddressModal, setShowAddressModal] = useState(false);

    return (
        <div
            key={id}
            className={'wallet-payment-method'}
        >
            {!isAbtraGiftCard && <IoMdCloseCircle
                onClick={() => setShowDeleteConfirmation(true)}
                className={'wallet-payment-method-delete-icon'}
            />}
            <div
                className={'wallet-payment-method-title'}>
                {isAbtraGiftCard && <p>Abtra Gift Card Wallet</p>}
            </div>
            <div
                className={'wallet-card-number'}
            >
                •••• •••• •••• {last4}
            </div>
            <div
                className={'wallet-expiration-date'}
            >
                expires in {expMonth && expYear ? `${expMonth}/${expYear}` : '-'}
            </div>
            <div
                className={'d-flex justify-content-between'}>
                <div
                    className={'wallet-card-holder-name'}
                >
                    {name}
                </div>
                {isAbtraGiftCard && <div
                    className={'wallet-card-available-credit'}
                >
                    {getSymbolFromCurrency(abtraGiftCardCurrency)} {abtraGiftCardCredit}
                </div>
                }
            </div>
            <div
                className={'wallet-payment-method-actions'}
            >
                <Button
                    variant={'light'}
                    onClick={() => setShowAddressModal(true)}
                >
                    Edit
                </Button>
                <span
                    className={'wallet-payment-method-icon'}
                >
                    <WalletPaymentMethodIcon
                        brand={brand}
                    />
                </span>
            </div>
            <DeletePaymentMethodModalConfirmation
                userId={userId}
                paymentMethodId={id}
                fetchPaymentMethods={fetchPaymentMethods}
                show={showDeleteConfirmation}
                handleClose={() => setShowDeleteConfirmation(false)}
            />
            <WalletPaymentMethodAddressModal
                billingAddress={billingAddress}
                userId={userId}
                paymentMethodId={id}
                handleClose={() => setShowAddressModal(false)}
                show={showAddressModal}
                fetchPaymentMethods={fetchPaymentMethods}
                countries={countries}
                isAbtraGiftCard={isAbtraGiftCard}
            />
        </div>
    );
}

WalletPaymentMethod.propTypes = {
    paymentMethod: object,
    userId: number,
    fetchPaymentMethods: func,
    countries: array,
    states: array,
    onCountryChange: func,
};

export default WalletPaymentMethod;